import { Button } from "@/components/ui/button";
import { Printer } from "lucide-react";

// Prints only the element with `targetId` (the browser dialog can also save it as a PDF).
export function PrintButton({ targetId, testid, label = "Print" }) {
  const go = () => {
    const el = document.getElementById(targetId);
    if (!el) return;
    el.classList.add("print-target");
    document.body.classList.add("printing-section");
    const done = () => {
      el.classList.remove("print-target");
      document.body.classList.remove("printing-section");
      window.removeEventListener("afterprint", done);
    };
    window.addEventListener("afterprint", done);
    window.print();
  };
  return (
    <Button size="sm" variant="outline" className="rounded-full print:hidden" onClick={go} data-testid={testid}>
      <Printer className="mr-2 h-4 w-4" />{label}
    </Button>
  );
}
